import { CompilerOptions, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BootstrapOptions } from '@angular/core/src/application_ref';

import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getTranslationProviders } from './app/shared/i18n/i18n-providers';

document.documentElement.lang = localStorage.getItem('lang') || 'de';

if (environment.production) {
	enableProdMode();
}

// we assume that environment.production means that we are using AOT
// you can define your own env parameters in /src/environments
getTranslationProviders(environment.production).then((providers: (CompilerOptions & BootstrapOptions) | Array<CompilerOptions & BootstrapOptions>) => {
	platformBrowserDynamic().bootstrapModule(AppModule, providers);
});



// WEBPACK FOOTER //
// ./src/main.ts